import * as React from 'react';
export default class ErrorBoundary extends React.Component {
    state = { hasError: false };
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        if (typeof this.props.onError === 'function') {
            // Loading failed, send this to a bug tracking service
            this.props.onError(error, errorInfo);
        }
    }
    render() {
        if (this.state.hasError) {
            // Let's not render anything so we don't show erroneous UI
            if (typeof this.props.errorMessage === 'function') {
                // If errorMessage is in props and it's a proper function, then call it
                return this.props.errorMessage(this.state.error);
            }
            return null;
        }
        return this.props.children;
    }
}
